import { render, staticRenderFns } from "./VIcon.vue?vue&type=template&id=2b311a5a&lang=pug&functional=true"
import script from "./VIcon.vue?vue&type=script&lang=js"
export * from "./VIcon.vue?vue&type=script&lang=js"
import style0 from "./VIcon.vue?vue&type=style&index=0&id=2b311a5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports